import { create } from 'zustand';

import type { TERM_CATEGORY } from '@/api';

export enum LOCAL_STORAGE_KEY {
  RECENT_SEARCH_LIST = 'recentSearchList',
  SEARCH_LOCATION_LIST = 'searchLocationList',
  BANNER_CLOSED = 'bannerClosed',
  WELLO_UUID = 'welloUuid',
  CARD_BANNER_CLOSED = 'cardBannerClosed',
}

interface WelloWebLinkModalPros {
  descriptions: string;
  link: string;
}

interface Log {
  data: string;
  time: Date;
}

type TermsDrawerMode = 'default' | 'bottom';

interface GlobalStore {
  termsDrawerType: TERM_CATEGORY | null;
  setTermsDrawerType: (termsDrawerType: TERM_CATEGORY | null) => void;
  termsDrawerMode: TermsDrawerMode;
  setTermsDrawerMode: (termsDrawerMode: TermsDrawerMode) => void;

  isHomeFooterModalOpen: boolean;
  setIsHomeFooterModalOpen: (isHomeFooterModalOpen: boolean) => void;

  welloWebLinkModalProps: WelloWebLinkModalPros | null;
  setWelloWebLinkModalProps: (
    welloWebLinkModal: WelloWebLinkModalPros | null,
  ) => void;

  isShowLoginRedirectionConfirmModal: boolean;
  setIsShowLoginRedirectionConfirmModal: (
    isShowLoginDirectionConformModal: boolean,
  ) => void;

  isShowAppInstallConfirmModal: boolean;
  setIsShowAppInstallConfirmModal: (
    isShowAppInstallConfirmModal: boolean,
  ) => void;

  isShowBenefitMaintenanceModal: boolean;
  setIsShowBenefitMaintenanceModal: (
    isShowBenefitMaintenanceModal: boolean,
  ) => void;

  isNaverMapMounted: boolean;
  setIsNaverMapMounted: (isNaverMapMounted: boolean) => void;

  logList: Log[];
  addLog: (log: Log) => void;

  handleLocationServiceConsentDrawer?: (
    isLocationServiceConsent: boolean,
  ) => Promise<void>;
  setHandleLocationServiceConsentDrawer: (
    handleLocationServiceConsentDrawer: GlobalStore['handleLocationServiceConsentDrawer'],
  ) => void;

  hideBottomNav: boolean;
  setHideBottomNav: (hideBottomNav: boolean) => void;
}

export const useGlobalStore = create<GlobalStore>((set) => {
  return {
    termsDrawerType: null,
    setTermsDrawerType: (termsDrawerType) => set({ termsDrawerType }),
    termsDrawerMode: 'default',
    setTermsDrawerMode: (termsDrawerMode) => set({ termsDrawerMode }),

    isHomeFooterModalOpen: false,
    setIsHomeFooterModalOpen: (isHomeFooterModalOpen) =>
      set({ isHomeFooterModalOpen }),

    welloWebLinkModalProps: null,
    setWelloWebLinkModalProps: (welloWebLinkModalProps) =>
      set({ welloWebLinkModalProps }),

    isShowLoginRedirectionConfirmModal: false,
    setIsShowLoginRedirectionConfirmModal: (
      isShowLoginRedirectionConfirmModal,
    ) => set({ isShowLoginRedirectionConfirmModal }),

    isShowAppInstallConfirmModal: false,
    setIsShowAppInstallConfirmModal: (isShowAppInstallConfirmModal) =>
      set({ isShowAppInstallConfirmModal }),

    isShowBenefitMaintenanceModal: false,
    setIsShowBenefitMaintenanceModal: (isShowBenefitMaintenanceModal) =>
      set({ isShowBenefitMaintenanceModal }),

    isNaverMapMounted: false,
    setIsNaverMapMounted: (isNaverMapMounted) => set({ isNaverMapMounted }),

    logList: [],
    addLog: (log) => set(({ logList }) => ({ logList: [...logList, log] })),

    // Drawe 띄우고 콜백 역할함
    setHandleLocationServiceConsentDrawer: (
      handleLocationServiceConsentDrawer,
    ) => set({ handleLocationServiceConsentDrawer }),

    hideBottomNav: false,
    setHideBottomNav: (hideBottomNav) => set({ hideBottomNav }),
  };
});
